import { FramerPage } from 'Pages/FramerPage';

const PrivacyPolicy = () => <FramerPage path="privacy-policy" />;

export default PrivacyPolicy;
